<template>
  <template v-if="thumbnail">
    <picture>
      <source media="(min-width:320px)" :srcset="image(media)" />
      <img
        lazy="eager"
        :src="image(media)"
        :alt="media.alt || 'Product Thumbnail'"
      />
    </picture>
  </template>
  <template v-else>
    <span v-if="zoom && isDesktop" :class="zooming ? 'zooming' : ''">
      <vue-image-zoomer
        :regular="image(media)"
        :zoom="media.zoom?.url"
        :show-message="false"
        :alt="media.alt || 'Product Image'"
        :click-zoom="true"
        @on-zoom="zooming = true"
        @off-zoom="zooming = false"
      >
        <img
          lazy="eager"
          :src="image(media)"
          :alt="media.alt || 'Product Image'"
          @load="emits('displayMedia')"
        />
      </vue-image-zoomer>
    </span>
    <video
      v-else-if="media.sources"
      playsinline
      :muted="!media.controls?.audio"
      :controls="media.controls?.controls"
      loop
      :data-autoplay="media.controls?.autoplay || !media.controls"
      :data-arrow-spacing="media.controls?.controls || media.subtitles"
      preload="metadata"
      :poster="media.previewImage.src"
      crossorigin="anonymous"
    >
      <source
        v-for="source in media.sources"
        :src="source.url"
        :type="source.mimeType"
      />
      <track
        v-if="media.subtitles"
        :src="media.subtitles"
        label="English"
        kind="captions"
        srclang="en-us"
        default=""
      />
    </video>
    <picture v-else @click="emits('updateModal', media)">
      <source media="(min-width:320px)" :srcset="image(media)" />
      <img
        lazy="eager"
        :src="image(media)"
        :alt="media.alt || 'Product Image'"
        @load="emits('displayMedia')"
      />
    </picture>
  </template>
</template>

<script setup>
import { ref, onBeforeMount, onBeforeUnmount } from 'vue';
import { VueImageZoomer } from 'vue-image-zoomer';

const zooming = ref(false);
const isDesktop = ref(false);
const emits = defineEmits(['displayMedia', 'updateModal']);
const props = defineProps({
  media: {
    required: true,
    type: Object,
  },
  zoom: {
    type: Boolean,
    default: false,
  },
  thumbnail: {
    type: Boolean,
    default: false,
  },
});

const checkWindowSize = () => (isDesktop.value = window.innerWidth >= 1025);
const image = (asset) => {
  const assetUrl = asset?.previewImage?.url ?? asset?.image?.url;
  const assetImage =
    props.thumbnail && assetUrl.includes('768x.jpg')
      ? assetUrl.replace('768x.jpg', '72x.jpg')
      : assetUrl;
  return assetImage;
};
onBeforeMount(() => {
  checkWindowSize();
  window.addEventListener('resize', () => checkWindowSize());
});

onBeforeUnmount(() => emits('displayMedia', false));
</script>
